import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { CmsUrl, CtaStyle } from '@digital-platform/rs-cms/domain';
import { NavMenuColumn } from '@digital-platform/rs-cms/domain';
import {
  CtaButtonComponent,
  NavigationHelperService,
  RichTextComponent,
  RichTextLinkComponent,
} from '@digital-platform/rs-cms/feature-ptypes';
import { InlineImageNavComponent } from '../inline-image-nav/inline-image-nav.component';

@Component({
  selector: 'digital-platform-desktop-menu',
  templateUrl: './desktop-menu.component.html',
  styleUrls: ['./desktop-menu.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InlineImageNavComponent,
    RichTextLinkComponent,
    RichTextComponent,
    CtaButtonComponent,
  ],
})
export class DesktopMenuComponent {
  private readonly navigationHelperService = inject(NavigationHelperService);
  @Input() activeMenu: NavMenuColumn[] | null = null;

  public viewAllLinkStyle: CtaStyle = {
    tid: 6106,
    name: 'Red Link -->',
    ctaStyle: 'button__link_primary',
  };
  public emptyViewAllLinkUrl: CmsUrl = [
    {
      uri: '',
      title: '',
      options: {
        attributes: {
          target: 0,
        },
      },
    },
  ];

  shouldRender(menu: NavMenuColumn) {
    return menu.column.some((column: any) => !column.link_image_url);
  }

  getViewAllLinkUrl(url = ''): CmsUrl {
    const retval = this.emptyViewAllLinkUrl;
    retval[0].uri = url;

    return retval;
  }

  getTarget(
    target: string | undefined,
    url: string | null
  ): '_blank' | '_self' | undefined {
    let shouldOpenNewTab = false;

    if (target) {
      shouldOpenNewTab = target === '_blank';
    } else {
      shouldOpenNewTab =
        this.navigationHelperService.isSupportedFile(url || '') ||
        this.navigationHelperService.isExternalUrl(url || '');
    }
    return shouldOpenNewTab ? '_blank' : '_self';
  }
}
